import { http, isExpired, HTTP_TOKEN, REJECT_MSG } from './http';

export const fetchManufacturers = (tokenLogin) => {
    const config = {
        headers: { Authorization: `Bearer ${tokenLogin ?? HTTP_TOKEN}`  }
    }

    const options = {
        "Esquema": "web",
        "Tabela": "Fornecedor"
    }

    return new Promise((resolve, reject) => {
        const ret = http.post(`Dados/ObterDados`, options, config);

        if (isExpired(ret)) {
            reject(REJECT_MSG);
        }

        resolve(ret);
    })
}